import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { SearchSpecification, SpecificationContract, SpecificationList } from '@celum/formats/domain';

/**
 * Minimal shape required from a specifications service to resolve `$ref`s within a contract. Both `SpecificationsService`
 * (tenant-scoped formats) and `SpecificationDefinitionsService` (base formats) satisfy this structurally, so the contract-
 * parsing helpers below don't need to depend on either concrete service.
 */
export interface ContractReferenceProvider {
  getContractReference(referenceUrl: string): Observable<SpecificationContract>;
}

/**
 * Minimal shape required from a specifications service by `SpecificationStore`. Both `SpecificationsService`
 * (tenant-scoped formats) and `SpecificationDefinitionsService` (base formats) satisfy this structurally, so
 * `SpecificationStore` (and the `FORMAT_SPECIFICATION_SERVICE` token below) can work with either without depending
 * on a concrete class - only the service bound to the token differs per route (see `formatsRouteProviders`/
 * `baseFormatsRouteProviders`).
 */
export interface SpecificationServiceLike extends ContractReferenceProvider {
  getSpecifications(search?: SearchSpecification): Observable<SpecificationList>;
  getSpecificationContract(specificationKey: string): Observable<SpecificationContract>;
}

export const FORMAT_SPECIFICATION_SERVICE = new InjectionToken<SpecificationServiceLike>('FORMAT_SPECIFICATION_SERVICE');
